import { Link, NavLink, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import styles from "./ReportsMenu.module.css";
import React from "react";

function ReportsMenu() {
  const navigate = useNavigate();
  const userLocation = JSON.parse(localStorage.getItem("userLogin")).location;
  return (
    <>
      <div className={styles.backButton}>
        <Button
          type="tertiary"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          Back to Calendar
        </Button>
      </div>
      <ul className={styles.menuList}>
        <li>
          <Link to="/reports/summary">Summary List</Link>
        </li>
      </ul>
    </>
  );
}

export default ReportsMenu;
